import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@material-ui/core';
import React, { useCallback } from 'react';

const FilterPopupMenu = ({ open, anchorRef, setOpen, options, handleOptionClick }) => {
    const handleClose = useCallback(
        event => {
            if (anchorRef.current && anchorRef.current.contains(event.target)) {
                return;
            }
            setOpen(false);
        },
        [anchorRef.current, setOpen]
    );

    return (
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                    }}
                >
                    <Paper style={{ backgroundColor: 'white' }}>
                        <ClickAwayListener onClickAway={handleClose}>
                            <MenuList autoFocusItem id="menu-list-grow">
                                {options.map(option => (
                                    <MenuItem
                                        key={option.key}
                                        onClick={() => handleOptionClick(option)}
                                    >
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
};

export default FilterPopupMenu;
